module.exports = __webpack_public_path__ + "img/logo14.c2399f3b.png";